import React from 'react'
import { Box, Grid, Typography } from '@mui/material'
import ServiceCard from './Job/ServiceCard'
import { useNavigate } from 'react-router-dom'

export default function BestServices({ services }) {
    const navigate = useNavigate();
    return (
        <>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', px: 2, mt: 10 }}>
                <Typography sx={{
                    fontFamily: "Inter",
                    fontWeight: 600,
                    fontSize: "30px",
                    lineHeight: "36px",
                    color: "#000000",
                    mb: 3
                }}>Best Services on PPLACD</Typography>
                <Typography className='text1Bold' sx={{ color: '#2544EE', cursor: 'pointer' }} onClick={() => navigate("/candidate/candidate-service")}>View all</Typography>
            </Box>


            <Grid container spacing={2} mt={4}  >
                {
                    services && services.length > 0
                        ?
                        services.slice(0, 4).map((service, index) => (
                            <Grid item md={6} key={index}>
                                <ServiceCard service={service} />
                            </Grid>
                        ))
                        :
                        ""
                }
            </Grid>
        </>
    )
}
